import { call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import { creators as StrategyActions } from '../../Reducers/Strategy';
import Api from '../../Api/ApiStrategy';

export function* getPlanHeaders() {
  try {
    const response = yield call(Api.getStrategyPlanHeaders, null);
    if (response.status === 200) {
      yield put(StrategyActions.strategySuccess({ planheaders: response.data }));
    } else {
      if (response.status !== 401) toast.error(response.message);
      yield put(StrategyActions.strategySuccess(response.message));
    }
  } catch (e) {
    yield put(StrategyActions.strategySuccess(e));
  }
}

export function* getPlanDetails({ payload }) {
  try {
    const response = yield call(Api.getStrategyPlanDetails, payload);
    if (response.status === 200) {
      yield put(StrategyActions.strategySuccess({
        plandetails: response.data,
        plandetailsPlanId: payload,
      }));
    } else {
      if (response.status !== 401) toast.error(response.message);
      yield put(StrategyActions.strategySuccess(response.message));
    }
  } catch (e) {
    yield put(StrategyActions.strategySuccess(e));
  }
}

export function* getPlanSummaries({ payload }) {
  try {
    const response = yield call(Api.getStrategyPlanSummaries, payload);
    if (response.status === 200) {
      yield put(StrategyActions.strategySuccess({
        plansummaries: response.data,
        plansummariesPlanId: payload,
      }));
    } else {
      if (response.status !== 401) toast.error(response.message);
      yield put(StrategyActions.strategySuccess(response.message));
    }
  } catch (e) {
    yield put(StrategyActions.strategySuccess(e));
  }
}
